// extracted by mini-css-extract-plugin
export default {"cls1":"CinePlayer-Loading-module--cls1--n2lnR","cls2":"CinePlayer-Loading-module--cls2--vu3Ju CinePlayer-Loading-module--cls1--n2lnR"};